import axios from "axios";
import uuid from "../validation/uuid";
import along from "@turf/along";
import is_uuid from "../validation/is_uuid";

import { get_toolbox_mode_list } from "../../App/validation/toolbox_mode_list";

import { bun_server } from "./baseUrl";
import circle from "@turf/circle";
import { get_transportation_profiles } from "../validation/transportation_profiles";
import { remove_from_map } from "../validation/geometry_helper";

const path_toolbox = "sini_v2";

const TOOLBOX_AREA = get_toolbox_mode_list().filter(t => t?.is_area);

export const status_toolbox = () => (dispatch) => {
  dispatch({
    type: "status_toolbox",
  });
};

export const set_value_toolbox = (body) => (dispatch) => {
  dispatch({
    type: "set_value_toolbox",
    payload: body,
  });
};

export const push_value_toolbox = (body) => (dispatch) => {
  dispatch({
    type: "push_value_toolbox",
    payload: body,
  });
  dispatch({
    type: "status_toolbox",
  });
};

export const push_value_toolbox_single = (body) => (dispatch) => {
  dispatch({
    type: "push_value_toolbox_single",
    payload: body,
  });
  dispatch({
    type: "status_toolbox",
  });
};

export const set_loading_toolbox = (loading_item) => (dispatch) => {
  dispatch({
    type: "set_loading_toolbox",
    payload: loading_item,
  });
};

export const clear_loading_toolbox = () => (dispatch) => {
  dispatch({
    type: "clear_loading_toolbox",
  });
};

export const change_radius = (body) => (dispatch) => {
  dispatch({
    type: "change_radius",
    payload: body,
  });
  dispatch({
    type: "status_toolbox",
  });
};

export const toolbox_handle_back = () => (dispatch, getState) => {
  const { toolbox = {}, layer = {} } = getState();
  const { mode_toolbox, uuid_name } = toolbox;
  const { map_object, draw_object } = layer;
  const features = toolbox[mode_toolbox];
  const source_id = mode_toolbox.replace("features", "geojson")

  if (map_object && map_object.getSource(source_id)) {
    features.forEach(f => {
      map_object.setFeatureState(
        { source: source_id, id: f.properties.uuid },
        { selected: false } // ✅ Langsung pake nilai baru
      );
    })
  }

  //ganti props
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "mode_toolbox",
      value: "",
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "selected_row_toolbox_ids",
      value: [],
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "description",
      value: "",
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "uuid_name",
      value: "",
    },
  });
  if (uuid_name) {
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: uuid_name,
        value: "",
      },
    });
  }
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "is_need_toolbox_companion",
      value: false,
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "name_toolbox",
      value: "",
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "mode_draw",
      value: "simple_select",
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "source_tab",
      value: 0,
    },
  });
  dispatch({
    type: "set_value_layer",
    payload: {
      key: "draw_state_platform",
      value: "",
    },
  });

  dispatch({
    type: "status_action"
  })

  //reset draw map
  if (map_object) {
    map_object.getCanvas().style.cursor = "";
    if (draw_object) {
      draw_object.changeMode("simple_select");
    }
  }

  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "start_time",
      value: null,
    },
  });
}

export const toolbox_handle_stop = () => (dispatch, getState) => {
  const { layer = {} } = getState();
  const { map_object, draw_object } = layer;

  if (map_object && draw_object) {
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "last_saved_feature_uuid",
        value: "",
      },
    });

    map_object.getCanvas().style.cursor = "";

    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "mode_draw",
        value: "simple_select",
      },
    });
    draw_object.changeMode("simple_select");

  }
}

export const show_poi = () => (dispatch, getState) => {
  const { layer, toolbox } = getState();
  const map = layer?.map_object;
  if (!map) return;

  const source = map.getSource("geojson_poi");
  if (!source) return; // early exit sekalian

  const { poi_inside_polygons, all_poi_features } = toolbox;

  // Edge case: kalau kosong, langsung clear dan return
  if (!all_poi_features?.length) {
    source.setData({ type: "FeatureCollection", features: [] });
    return;
  }

  const showPoiUuidSet = new Set();

  for (const tool of TOOLBOX_AREA) {
    const featureKey = tool.key;
    const visibleKey = featureKey.replace("features", "visible"); // precompute kalau bisa
    const features = toolbox[featureKey];
    const visibleFeatures = toolbox[visibleKey];
    if (!features?.length || !visibleFeatures?.length) continue;

    const visibleSet = new Set(visibleFeatures);

    for (const feature of features) {
      const uuid = feature?.properties?.uuid;
      if (!uuid || !visibleSet.has(uuid)) continue;

      const pois = poi_inside_polygons[uuid];
      if (!pois?.length) continue;

      for (const poi of pois) {
        showPoiUuidSet.add(poi.key);
      }
    }
  }

  // Short-circuit kalau nggak ada POI yang perlu ditampilkan
  const features = showPoiUuidSet.size === 0
    ? []
    : all_poi_features.filter(poi => showPoiUuidSet.has(poi.key));

  source.setData({ type: "FeatureCollection", features });
};


export const toolbox_handle_new_object = () => (dispatch, getState) => {
  const { toolbox = {}, layer = {} } = getState();
  const { map_object, draw_object } = layer;
  const { mode_toolbox, } = toolbox;
  const features = toolbox[mode_toolbox];
  const instruction = get_toolbox_mode_list(mode_toolbox)?.first_point || "";

  if (map_object && draw_object) {
    // ini diibaratkan sebagai commmit untuk toolbox
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "cursor_mode",
        value: instruction,
      },
    });
    const last_saved = features?.at(-1)?.properties?.uuid || "start";
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "last_saved_feature_uuid",
        value: last_saved,
      },
    });

    map_object.getCanvas().style.cursor = "crosshair";
    const new_mode_draw = get_toolbox_mode_list(mode_toolbox)?.mode || "simple_select"
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "mode_draw",
        value: new_mode_draw,
      },
    });

    draw_object.changeMode(new_mode_draw);

    dispatch({
      type: "status_action"
    })
  }
}

export const reset_grid = () => (dispatch, getState) => {
  const { layer = {} } = getState();
  const { map_object } = layer;

  dispatch(set_value_toolbox({
    key: "layer_list_point_obj",
    value: {},
  }));
  dispatch(set_value_toolbox({
    key: "layer_list_polygon_obj",
    value: {},
  }));

  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "mode_toolbox",
      value: "",
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "current_grid_group",
      value: 0,
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "total_grid_group",
      value: 1,
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "features_grid_raw",
      value: [],
    },
  });
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "features_grid",
      value: [],
    },
  });

  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "toolbox_grid_object",
      value: {
        layer_point_ids: [],
        layer_polygon_ids: [],
        grid_mode: "square", //square, hex
        grid_size_mode: "count", //count, width
        grid_counts: 200,
        grid_width_meters: 5,
        bbox_mode: "polygon", //point, polygon
        unit_density: "m_square", //m_square, km_square
        total_square_meters: 0,
        total_poi_initial: 0,
        item_name: "", //bebas isi
        min_grid_value: 0,
        max_grid_value: 1,
      },
    },
  });

  if (!map_object) return;

  const polygon_source_id = "toolbox_gcp_polygon"; //polygon
  const point_source_id = "toolbox_gcp_point"; //point
  const layer_grid_polygon_id = "GRID_TOOLBOX_POLYGON"; //grid
  remove_from_map(map_object, polygon_source_id)
  remove_from_map(map_object, point_source_id)
  remove_from_map(map_object, layer_grid_polygon_id)
}

export const toolbox_handle_cancel = () => (dispatch, getState) => {
  const { toolbox = {}, layer = {} } = getState();
  const {
    mode_toolbox,
    uuid_name,
    last_saved_feature_uuid,
    poi_inside_polygons,
    features_area_center,
    features_isochrone_polygon,
    point_inside_elevation_line,
    features_elevation_center,
    all_poi_features,
  } = toolbox;
  const features = toolbox[mode_toolbox];

  if (mode_toolbox === "scoring_grids") {
    dispatch(reset_grid());
    return;
  };

  const visible_name = mode_toolbox.replace("features", 'visible');
  const visible_features = toolbox?.[visible_name];
  const selected_row_toolbox_ids = toolbox[uuid_name] || [];
  const { map_object } = layer;
  let mode_id = ""

  if (!last_saved_feature_uuid) return;

  const feature_label_name = `${mode_toolbox}_label`;
  const feature_center_name = `${mode_toolbox}_center`;
  const features_label = toolbox?.[feature_label_name];
  const features_center = toolbox?.[feature_center_name];

  let start_delete_index = -1;
  if (last_saved_feature_uuid === "start") {
    start_delete_index = 0;
  } else if (is_uuid(last_saved_feature_uuid)) {
    start_delete_index = features.findIndex(f => f.properties.uuid === last_saved_feature_uuid) + 1;
  }
  if (start_delete_index === -1) return;

  const features_will_be_delete = features?.slice(start_delete_index, features.length)?.map(f => f?.properties?.uuid)

  const new_features = features.filter(f => !features_will_be_delete.includes(f.properties.uuid))
  const new_visibles = visible_features.filter(uuid => !features_will_be_delete.includes(uuid))
  const new_selected_row_toolbox_ids = selected_row_toolbox_ids?.filter(uuid => !features_will_be_delete.includes(uuid))

  // update yang di mapnya
  if (!map_object) return;

  if (mode_toolbox === "features_distance") {
    mode_id = "geojson_distance"
    const new_features_label = features_label.filter(item => !features_will_be_delete.includes(item.properties.parent_uuid))
    const new_features_center = []

    if (map_object?.getSource(`${mode_id}`))
      map_object.getSource(`${mode_id}`).setData({
        type: 'FeatureCollection',
        features: new_features
      })

    const will_be_deleted_features_center = []
    features_center.forEach(item => {
      if (!features_will_be_delete.includes(item.properties.uuid)) new_features_center.push(item)
      else will_be_deleted_features_center.push(item.properties.uuid)
    })

    // label feature untuk menampilkan titik A ke titik B
    map_object.getSource('geojson_distance_label')?.setData({
      type: 'FeatureCollection',
      features: new_features_label
    });
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: feature_label_name,
        value: new_features_label
      },
    });

    // label tengah untuk menampilkan/menghapus "D-1" dll
    will_be_deleted_features_center.forEach((uuid) => {
      const marker_to_remove = document.getElementById(`marker_toolbox_${uuid}`);
      if (marker_to_remove) marker_to_remove.remove();
    })

    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: feature_center_name,
        value: new_features_center
      },
    });

    // menghilangkan selection dalam gambar peta
    will_be_deleted_features_center.forEach(uuid => {
      // Set feature state sesuai state yang BARU
      map_object.setFeatureState(
        { source: mode_id, id: uuid },
        { selected: false } // ✅ Langsung pake nilai baru
      );
    })
  } else if (mode_toolbox === "features_radius") {
    mode_id = "geojson_radius"

    let new_poi_inside_polygons = { ...poi_inside_polygons }
    const deletedPoiUuidSet = new Set();
    features_will_be_delete.forEach((uuid) => {
      const marker_to_remove = document.getElementById(`marker_toolbox_${uuid}`);
      if (marker_to_remove) marker_to_remove.remove();

      // hapus data dan layer poi
      const source_id_poi = `geojson_poi_${uuid}`;
      dispatch({
        type: "remove_source_and_layer_from_map",
        payload: source_id_poi
      });

      // hapus data poi dari redux
      const pois = new_poi_inside_polygons[uuid] || [];
      pois.forEach(poi => deletedPoiUuidSet.add(poi.key));
      delete new_poi_inside_polygons[uuid];
    })

    const new_all_poi_features = all_poi_features.filter(
      poi => !deletedPoiUuidSet.has(poi.key)
    );

    dispatch(set_value_toolbox({
      key: "all_poi_features",
      value: new_all_poi_features
    }))

    const source_id_poi = `geojson_poi`;
    if (map_object?.getSource(source_id_poi))
      map_object.getSource(source_id_poi).setData({
        type: 'FeatureCollection',
        features: new_all_poi_features
      });

    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "poi_inside_polygons",
        value: new_poi_inside_polygons
      }
    });

    // render ulang yang tidak terhapus
    const polygon_features_will_keep_features = new_features.map((feature_point) => {
      return circle(feature_point, feature_point.properties.radius_km, {
        steps: 100,
        units: "kilometers",
        properties: feature_point.properties,
      })
    })

    if (map_object.getSource(mode_id))
      map_object.getSource(mode_id).setData({
        type: 'FeatureCollection',
        features: polygon_features_will_keep_features
      })

    if (map_object.getSource(`${mode_id}_line`))
      map_object.getSource(`${mode_id}_line`).setData({
        type: 'FeatureCollection',
        features: polygon_features_will_keep_features
      })

    new_features.forEach(f => {
      map_object.setFeatureState(
        { source: mode_id, id: f.properties.uuid },
        { selected: false } // ✅ Langsung pake nilai baru
      );
    })

    dispatch({
      type: "set_value_toolbox",
      payload: { key: "poi_fetched_layer_ids_per_radius", value: {} }
    })
  } else if (mode_toolbox === "features_area") {
    mode_id = "geojson_area"

    if (map_object?.getSource(mode_id))
      map_object.getSource(mode_id).setData({
        type: 'FeatureCollection',
        features: new_features
      });

    // hapus label khusus area
    const new_features_area_center = features_area_center.filter(f => !features_will_be_delete.includes(f.properties.uuid))
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "features_area_center",
        value: new_features_area_center
      },
    });

    let new_poi_inside_polygons = { ...poi_inside_polygons }
    const deletedPoiUuidSet = new Set();
    features_will_be_delete.forEach((uuid) => {
      const marker_to_remove = document.getElementById(`marker_toolbox_${uuid}`);
      if (marker_to_remove) marker_to_remove.remove();

      // hapus data dan layer poi
      const source_id_poi = `geojson_poi_${uuid}`;
      dispatch({
        type: "remove_source_and_layer_from_map",
        payload: source_id_poi
      });

      // hapus data poi dari redux
      const pois = new_poi_inside_polygons[uuid] || [];
      pois.forEach(poi => deletedPoiUuidSet.add(poi.key));
      delete new_poi_inside_polygons[uuid];
    })

    const new_all_poi_features = all_poi_features.filter(
      poi => !deletedPoiUuidSet.has(poi.key)
    );

    dispatch(set_value_toolbox({
      key: "all_poi_features",
      value: new_all_poi_features
    }))

    const source_id_poi = `geojson_poi`;
    if (map_object?.getSource(source_id_poi))
      map_object.getSource(source_id_poi).setData({
        type: 'FeatureCollection',
        features: new_all_poi_features
      });

    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "poi_inside_polygons",
        value: new_poi_inside_polygons
      }
    });

    features_will_be_delete.forEach(uuid => {
      // Set feature state sesuai state yang BARU
      map_object.setFeatureState(
        { source: mode_id, id: uuid },
        { selected: false } // ✅ Langsung pake nilai baru
      );
    })

    dispatch({
      type: "set_value_toolbox",
      payload: { key: "poi_fetched_layer_ids_per_area", value: {} }
    })
  } else if (mode_toolbox === "features_isochrone") {
    mode_id = "geojson_isochrone_polygon"

    let new_poi_inside_polygons = { ...poi_inside_polygons }
    const deletedPoiUuidSet = new Set();
    features_will_be_delete.forEach((uuid) => {
      const marker_to_remove = document.getElementById(`marker_toolbox_${uuid}`);
      if (marker_to_remove) marker_to_remove.remove();

      // hapus data dan layer poi
      const source_id_poi = `geojson_poi_${uuid}`;
      dispatch({
        type: "remove_source_and_layer_from_map",
        payload: source_id_poi
      });

      // hapus data poi dari redux
      const pois = new_poi_inside_polygons[uuid] || [];
      pois.forEach(poi => deletedPoiUuidSet.add(poi.key));
      delete new_poi_inside_polygons[uuid];

      map_object.setFeatureState(
        { source: mode_id, id: uuid },
        { selected: false } // ✅ Langsung pake nilai baru
      );
    })

    const new_all_poi_features = all_poi_features.filter(
      poi => !deletedPoiUuidSet.has(poi.key)
    );

    dispatch(set_value_toolbox({
      key: "all_poi_features",
      value: new_all_poi_features
    }))

    const source_id_poi = `geojson_poi`;
    if (map_object?.getSource(source_id_poi))
      map_object.getSource(source_id_poi).setData({
        type: 'FeatureCollection',
        features: new_all_poi_features
      });

    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "poi_inside_polygons",
        value: new_poi_inside_polygons
      }
    });

    // hapus feature polygon yang masuk features_will_be_delete
    let new_features_isochrone_polygon = {}
    Object.keys(features_isochrone_polygon).forEach(uuid => {
      if (features_isochrone_polygon?.[uuid] && !features_will_be_delete.includes(uuid)) {
        new_features_isochrone_polygon[uuid] = features_isochrone_polygon[uuid]
      }
    })
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "features_isochrone_polygon",
        value: new_features_isochrone_polygon,
      },
    });

    if (map_object.getSource(mode_id))
      map_object.getSource(mode_id).setData({
        type: 'FeatureCollection',
        features: Object.keys(new_features_isochrone_polygon).map(uuid => new_features_isochrone_polygon[uuid])
      })

    dispatch({
      type: "set_value_toolbox",
      payload: { key: "poi_fetched_layer_ids_per_isochrone", value: {} }
    })
  } else if (mode_toolbox === "features_elevation") {
    mode_id = "geojson_elevation"

    let new_point_inside_elevation_line = structuredClone(point_inside_elevation_line);
    let features_uuid_elevation_center_will_be_delete = [];
    let new_features_elevation_center = features_elevation_center.filter(f => !features_will_be_delete.includes(f.properties.uuid))
    features_will_be_delete.forEach(uuid => {
      delete new_point_inside_elevation_line[uuid];
      features_uuid_elevation_center_will_be_delete.push(uuid);
    })

    // update yang di mapnya
    if (map_object.getSource(mode_id))
      map_object.getSource(mode_id).setData({
        type: 'FeatureCollection',
        features: new_features
      })

    // update titik yang berada di dalam garis elevasi
    if (map_object.getSource(`${mode_id}_point`)) {
      dispatch({
        type: "set_value_toolbox",
        payload: {
          key: "point_inside_elevation_line",
          value: new_point_inside_elevation_line
        },
      });

      map_object.getSource(`${mode_id}_point`).setData({
        type: 'FeatureCollection',
        features: Object.keys(new_point_inside_elevation_line).map(uuid => new_point_inside_elevation_line[uuid])
      })
    }


    // unselect (tidak mode highlight) yang masih tersisa di map
    new_features.forEach(f => {
      map_object.setFeatureState(
        { source: mode_id, id: f.properties.uuid },
        { selected: false } // ✅ Langsung pake nilai baru
      );
    })

    // label tengah untuk menampilkan/menghapus "D-1" dll
    // dan hapus juga layer poi jika ada
    features_uuid_elevation_center_will_be_delete.forEach((uuid, idx) => {
      // hapus marker
      const marker_to_remove = document.getElementById(
        `marker_toolbox_${uuid}`,
      );
      if (marker_to_remove) marker_to_remove.remove();
    });
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "features_elevation_center",
        value: new_features_elevation_center
      },
    });


  }

  // set features yang terlihat (dishow)
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: visible_name,
      value: new_visibles,
    },
  });

  // set features asli
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: mode_toolbox,
      value: new_features
    },
  });

  // if (mode_id) {
  //   map_object.getSource(mode_id)?.setData({
  //     type: 'FeatureCollection',
  //     features: new_features
  //   });
  // }

  // set feature yang diselect
  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: uuid_name,
      value: new_selected_row_toolbox_ids
    },
  });

  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "layer_ids_poi",
      value: []
    },
  });

  dispatch({
    type: "set_value_toolbox",
    payload: {
      key: "start_time",
      value: null,
    },
  });
}

/**
 *
 * @param {*} body = {
 * geo_layer_id,
 * features_filtered
 * }
 * @returns
 */
export const set_geojson_filtered = (body) => (dispatch) => {
  dispatch({
    type: "set_geojson_filtered",
    payload: body,
  });
  dispatch({
    type: "status_action",
  });
};

// export const generate_elevation = (feature, number_of_samples) => async (dispatch, getState) => {
//   try {
//     dispatch(set_loading_toolbox("generate_elevation"));
//     dispatch({
//       type: "set_value_toolbox",
//       payload: {
//         key: "loading_status",
//         value: true
//       },
//     });
//     const { toolbox, layer } = getState() || {};
//     const { map_object } = layer || {};

//     const elevation_id = "geojson_elevation";
//     const { uuid_name, point_inside_elevation_line, elevation_chart_array } = toolbox || {};
//     const selected_row_toolbox_ids = toolbox?.[uuid_name] || [];
//     /*
//     `https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2/tilequery/${ft.geometry.coordinates[0]},${ft.geometry.coordinates[1]}.json?layers=contour&limit=1&access_token=pk.eyJ1IjoibWFwaWQiLCJhIjoiY2pqNWtnaW10MGNnMjNrcWg5MHQwY21nNiJ9.voWwMqU73TCDDua3mGCb8g`

//     */
//     const length_km = feature?.properties?.length_km;

//     const unit = number_of_samples - 1 || 9;
//     const delta = length_km / unit;
//     //generate array along
//     let array_along = [];
//     let features_elevation_point = [];

//     //chart
//     let data = [];
//     let labels = [];
//     let distances = [];
//     for (let index = 0; index <= unit; index++) {
//       const value = parseFloat((delta * index).toFixed(3));
//       array_along.push(value);
//     }

//     const delay_constant = 0;
//     const delay_promise = () =>
//       new Promise((res) => setTimeout(res, delay_constant));
//     const parent_function = () => {
//       return array_along.reduce(
//         (last_promise, item, index) =>
//           last_promise.then(async (result_sum) =>
//             await child_function(item, index).then((result_current) => [
//               ...result_sum,
//               result_current,
//             ])
//           ),
//         Promise.resolve([])
//       );
//     };
//     const child_function = async (item, index) => {
//       return delay_promise().then(() => {
//         const core_function = async () => {
//           try {
//             const options = { units: "kilometers" };
//             let point = along(feature, item, options);
//             const res = await axios.get(
//               `https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2/tilequery/${point.geometry.coordinates[0]},${point.geometry.coordinates[1]}.json?layers=contour&limit=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`
//             );
//             const elevation = res?.data?.features?.[0]?.properties?.ele;
//             data.push(elevation);
//             labels.push(index);
//             distances.push(item);
//             point.properties.elevation_m = elevation;
//             point.properties.distance_m = item;
//             point.properties.uuid = uuid();
//             point.properties.parent_uuid = feature?.properties?.uuid;
//             features_elevation_point.push(point);
//           } catch (error) { }
//         };
//         return core_function();
//       });
//     };

//     await parent_function().then(() => {
//       // console.log(
//       //   "features_elevation_point.length=",
//       //   features_elevation_point.length
//       // );
//       const first = features_elevation_point?.[0]?.properties?.elevation_m;
//       const last =
//         features_elevation_point?.[features_elevation_point?.length - 1]
//           ?.properties?.elevation_m;

//       const delta_elevation_m = last - first;
//       // feature.properties.delta_elevation_m = delta_elevation_m;

//       const state = getState();
//       const { features_elevation, visible_elevation } = state.toolbox;
//       let feature_index = features_elevation.findIndex(f => f.properties.uuid === feature.properties.uuid);
//       let new_feature_elevation = [...features_elevation];
//       let feature_elevation = features_elevation?.[feature_index];
//       const { min, max, avg } = getMinMaxAvg(features_elevation_point)

//       feature_elevation.properties.delta_elevation_m = delta_elevation_m;
//       feature_elevation.properties.elevation_min = min;
//       feature_elevation.properties.elevation_max = max;
//       feature_elevation.properties.elevation_avg = avg;
//       new_feature_elevation[feature_index] = feature_elevation;

//       dispatch({
//         type: "set_value_toolbox",
//         payload: { key: "features_elevation", value: new_feature_elevation },
//       });

//       const new_point_inside_elevation_line = {
//         ...point_inside_elevation_line,
//         [feature.properties.uuid]: features_elevation_point
//       }

//       const geojson_elevation_point = {
//         type: "FeatureCollection",
//         features: Object.keys(new_point_inside_elevation_line)
//           .filter((uuid) => visible_elevation.includes(uuid),
//           ).map((uuid) => new_point_inside_elevation_line[uuid])
//       };

//       if (!map_object.getSource(`${elevation_id}_point`)) {
//         map_object.addSource(`${elevation_id}_point`, {
//           type: "geojson",
//           data: geojson_elevation_point,
//           cluster: false,
//         });
//       } else {
//         map_object.getSource(`${elevation_id}_point`).setData(geojson_elevation_point);
//       }

//       if (map_object?.getLayer(`${elevation_id}_point`))
//         map_object?.setPaintProperty(
//           `${elevation_id}_point`,
//           "circle-radius",
//           [
//             "case",
//             [
//               "in",
//               ["get", "parent_uuid"],
//               ["literal", selected_row_toolbox_ids]
//             ],
//             5,
//             2
//           ]
//         );

//       dispatch({
//         type: "set_value_toolbox",
//         payload: {
//           key: "point_inside_elevation_line",
//           value: new_point_inside_elevation_line,
//         },
//       });

//       if (elevation_chart_array?.[feature_index]) {
//         const new_elevation_chart_array = [...elevation_chart_array];
//         new_elevation_chart_array[feature_index].data = data;
//         new_elevation_chart_array[feature_index].labels = labels;
//         new_elevation_chart_array[feature_index].distances = distances;

//         dispatch({
//           type: "set_value_toolbox",
//           payload: {
//             key: "elevation_chart_array",
//             value: new_elevation_chart_array,
//           },
//         });

//       } else {
//         dispatch({
//           type: "push_value_toolbox",
//           payload: {
//             key: "elevation_chart_array",
//             value: [
//               {
//                 parent_uuid: feature?.properties?.uuid,
//                 data,
//                 labels,
//                 distances,
//               },
//             ],
//           },
//         });
//       }


//       dispatch({
//         type: "status_toolbox",
//       });
//       dispatch({
//         type: "set_value_toolbox",
//         payload: {
//           key: "loading_status",
//           value: false
//         },
//       });
//       dispatch(clear_loading_toolbox());

//       return features_elevation_point;
//     });
//   } catch (error) { }
// };

export const generate_elevation_mapbox = (feature, number_of_samples) => async (dispatch, getState) => {
  const config = {
    headers: {
      accesstoken: localStorage.token_mapid,
    },
  };
  try {
    dispatch(set_loading_toolbox("generate_elevation"));
    dispatch({
      type: "set_value_toolbox",
      payload: {
        key: "loading_status",
        value: true
      },
    });
    const { toolbox, layer } = getState() || {};
    const { map_object } = layer || {};

    const elevation_id = "geojson_elevation";
    const { uuid_name, point_inside_elevation_line, elevation_chart_array } = toolbox || {};
    const selected_row_toolbox_ids = toolbox?.[uuid_name] || [];
    /*
    `https://api.mapbox.com/v4/mapbox.mapbox-terrain-v2/tilequery/${ft.geometry.coordinates[0]},${ft.geometry.coordinates[1]}.json?layers=contour&limit=1&access_token=pk.eyJ1IjoibWFwaWQiLCJhIjoiY2pqNWtnaW10MGNnMjNrcWg5MHQwY21nNiJ9.voWwMqU73TCDDua3mGCb8g`

    */
    const length_km = feature?.properties?.length_km;

    const unit = number_of_samples - 1 || 9;
    const delta = length_km / unit;
    //generate array along
    let array_along = [];
    let features_elevation_point = [];

    //chart
    let data = [];
    let labels = [];
    let distances = [];
    for (let index = 0; index <= unit; index++) {
      const value = parseFloat((delta * index).toFixed(3));
      array_along.push(value);
    }

    const delay_constant = 0;
    const delay_promise = () =>
      new Promise((res) => setTimeout(res, delay_constant));
    const parent_function = () => {
      return array_along.reduce(
        (last_promise, item, index) =>
          last_promise.then(async (result_sum) =>
            await child_function(item, index).then((result_current) => [
              ...result_sum,
              result_current,
            ])
          ),
        Promise.resolve([])
      );
    };
    const child_function = async (item, index) => {
      return delay_promise().then(() => {
        const core_function = async () => {
          try {
            const options = { units: "kilometers" };
            let point = along(feature, item, options);
            const res = await axios.get(
              `${bun_server}/${path_toolbox}/elevation/${point.geometry.coordinates[0]},${point.geometry.coordinates[1]}.json?layers=contour&limit=1`,
              config
            );
            const elevation = res?.data?.features?.[0]?.properties?.ele;
            data.push(elevation);
            labels.push(index);
            distances.push(item);
            point.properties.elevation_m = elevation;
            point.properties.distance_m = item;
            point.properties.uuid = uuid();
            point.properties.parent_uuid = feature?.properties?.uuid;
            features_elevation_point.push(point);
          } catch (error) { }
        };
        return core_function();
      });
    };

    await parent_function().then(() => {
      // console.log(
      //   "features_elevation_point.length=",
      //   features_elevation_point.length
      // );
      const first = features_elevation_point?.[0]?.properties?.elevation_m;
      const last =
        features_elevation_point?.[features_elevation_point?.length - 1]
          ?.properties?.elevation_m;

      const delta_elevation_m = last - first;
      // feature.properties.delta_elevation_m = delta_elevation_m;

      const state = getState();
      const { features_elevation, visible_elevation } = state.toolbox;
      let feature_index = features_elevation.findIndex(f => f.properties.uuid === feature.properties.uuid);
      let new_feature_elevation = [...features_elevation];
      let feature_elevation = features_elevation?.[feature_index];
      const { min, max, avg } = getMinMaxAvg(features_elevation_point)

      feature_elevation.properties.delta_elevation_m = delta_elevation_m;
      feature_elevation.properties.elevation_min = min;
      feature_elevation.properties.elevation_max = max;
      feature_elevation.properties.elevation_avg = avg;
      new_feature_elevation[feature_index] = feature_elevation;

      dispatch({
        type: "set_value_toolbox",
        payload: { key: "features_elevation", value: new_feature_elevation },
      });

      const new_point_inside_elevation_line = {
        ...point_inside_elevation_line,
        [feature.properties.uuid]: features_elevation_point
      }

      const geojson_elevation_point = {
        type: "FeatureCollection",
        features: Object.keys(new_point_inside_elevation_line)
          .filter((uuid) => visible_elevation.includes(uuid),
          ).map((uuid) => new_point_inside_elevation_line[uuid])
      };

      if (!map_object.getSource(`${elevation_id}_point`)) {
        map_object.addSource(`${elevation_id}_point`, {
          type: "geojson",
          data: geojson_elevation_point,
          cluster: false,
        });
      } else {
        map_object.getSource(`${elevation_id}_point`).setData(geojson_elevation_point);
      }

      if (map_object?.getLayer(`${elevation_id}_point`))
        map_object?.setPaintProperty(
          `${elevation_id}_point`,
          "circle-radius",
          [
            "case",
            [
              "in",
              ["get", "parent_uuid"],
              ["literal", selected_row_toolbox_ids]
            ],
            5,
            2
          ]
        );

      dispatch({
        type: "set_value_toolbox",
        payload: {
          key: "point_inside_elevation_line",
          value: new_point_inside_elevation_line,
        },
      });

      if (elevation_chart_array?.[feature_index]) {
        const new_elevation_chart_array = [...elevation_chart_array];
        new_elevation_chart_array[feature_index].data = data;
        new_elevation_chart_array[feature_index].labels = labels;
        new_elevation_chart_array[feature_index].distances = distances;

        dispatch({
          type: "set_value_toolbox",
          payload: {
            key: "elevation_chart_array",
            value: new_elevation_chart_array,
          },
        });

      } else {
        dispatch({
          type: "push_value_toolbox",
          payload: {
            key: "elevation_chart_array",
            value: [
              {
                parent_uuid: feature?.properties?.uuid,
                data,
                labels,
                distances,
              },
            ],
          },
        });
      }


      dispatch({
        type: "status_toolbox",
      });
      dispatch({
        type: "set_value_toolbox",
        payload: {
          key: "loading_status",
          value: false
        },
      });
      dispatch(clear_loading_toolbox());

      return features_elevation_point;
    });
  } catch (error) { }
};

export const generate_isochrone = (feature) => async (dispatch) => {
  try {
    const feature_new = { ...feature };

    dispatch(set_loading_toolbox("generate_isochrone"));

    const [long, lat] = feature_new.geometry.coordinates;
    let { isochrone_profile, distance_limit, time_limit } =
      feature_new.properties;

    isochrone_profile = isochrone_profile || "car";

    let params = `key=${process.env.REACT_APP_BASEMAP_KEY}&point=${lat},${long}`
    if (distance_limit) params += `&distance_limit=${distance_limit}`;
    if (time_limit) params += `&time_limit=${time_limit}`;
    if (feature?.properties?.isochrone_profile) params += `&profile=${isochrone_profile}`;
    const url = `https://routing.mapid.io/isochrone?${params}`;

    const response = await axios.get(url);

    let feature_result = response.data?.polygons?.[0];
    feature_result.properties.uuid = feature.properties.uuid;
    feature_result.properties.isochrone_profile = isochrone_profile;
    feature_result.properties.distance_limit = distance_limit;
    feature_result.properties.time_limit = time_limit;
    feature_result.id = feature.properties.uuid;

    return feature_result;
  } catch (error) {
    console.error("Error fetching isokron:", error);
  }
};

export const generate_isochrone_mapbox = (feature) => async (dispatch) => {
  const config = {
    headers: {
      accesstoken: localStorage.token_mapid,
    },
  };
  try {

    const feature_new = { ...feature };

    dispatch(set_loading_toolbox("generate_isochrone"));

    const [long, lat] = feature_new.geometry.coordinates;
    let { isochrone_profile, distance_limit, time_limit } =
      feature_new.properties;

    const profile = get_transportation_profiles(isochrone_profile)?.mapbox || "mapbox/driving-traffic";

    let params = ``
    if (distance_limit) params += `&distance_limit=${distance_limit}`;
    if (time_limit) params += `&time_limit=${time_limit}`;
    if (feature?.properties?.isochrone_profile) params += `&profile=${profile}`;
    const url = `${bun_server}/${path_toolbox}/isochrone/${long}%2C${lat}/?${params}`;

    const response = await axios.get(url, config);

    let feature_result = response.data?.features?.[0];
    feature_result.properties.uuid = feature.properties.uuid;
    feature_result.properties.isochrone_profile = isochrone_profile;
    feature_result.properties.distance_limit = distance_limit;
    feature_result.properties.time_limit = time_limit * 60;
    feature_result.id = feature.properties.uuid;

    return feature_result;
  } catch (error) {
    console.error("Error fetching isokron:", error);
  }
};

export const toolbox_handle_routing_mapbox = () => async (dispatch, getState) => {
  const config = {
    headers: {
      accesstoken: localStorage.token_mapid,
    },
  };
  const { toolbox = {}, layer = {} } = getState();
  const { map_object } = layer;
  const { routing_profile, routing_active_uuid, features_routing_obj = {} } = toolbox;
  const profile = get_transportation_profiles(routing_profile);
  let base_url = `${bun_server}/${path_toolbox}/routing`;

  let features_routing_point = features_routing_obj?.data?.[routing_active_uuid]?.point || [];
  let new_features_routing_point = [];
  if (profile?.mapbox && features_routing_point?.length >= 2) {
    const coordinates = features_routing_point.map(f => {
      return `${f.geometry.coordinates[0]},${f.geometry.coordinates[1]}`
    }).join(";")
    const url = `${base_url}/${coordinates}?profile=${profile.mapbox}&geometries=geojson&overview=full`
    const response = await axios.get(url, config);
    if (response.status === 200) {
      const { geometry, duration, distance } = response.data.routes[0] || {};
      let old_feature = features_routing_obj?.data?.[routing_active_uuid]?.lineString;
      let new_feature;
      if (old_feature) {
        new_feature = {
          ...old_feature,
          geometry: geometry,
          properties: {
            ...old_feature.properties,
            routing_profile: routing_profile, //driving, walking, cycling
            // id_tool,
            duration_sec: duration,
            distance_m: distance
          },
        }
      } else {
        new_feature = {
          type: "Feature",
          properties: {
            uuid: routing_active_uuid,
            routing_profile: routing_profile, //driving, walking, cycling
            // id_tool,
            duration_sec: duration,
            distance_m: distance
          },
          geometry: {
            type: "LineString",
            coordinates: geometry.coordinates,
          },
        };
      }

      for (const [index, item] of features_routing_point.entries()) {
        const waypoints = response.data?.waypoints || [];
        let name = waypoints[index]?.name;
        if (!name || !isNaN(name)) {
          const url_point = `https://nominatim.mapid.io/reverse?lat=${item.geometry.coordinates[1]}&lon=${item.geometry.coordinates[0]}&format=json`
          const response_point = await axios.get(url_point);
          const display_name = response_point?.data?.display_name;
          const { road, neighbourhood, village, country } = response_point?.data?.address || {}
          if (road && isNaN(road)) name = road;
          else if (neighbourhood) name = neighbourhood;
          else if (village) name = village;
          else if (country) name = country;
          else if (display_name && isNaN(display_name)) name = display_name;
          else name = item.geometry.coordinates.map(number => Number(number).toFixed(5)).join(", ");
        }

        new_features_routing_point.push({
          ...item,
          properties: {
            ...item.properties,
            routing_profile: routing_profile, //driving, walking, cycling
            name: name,
            distance_m: waypoints[index]?.distance || 0,
          },
        })
      }

      dispatch({
        type: "set_value_toolbox",
        payload: {
          key: "features_routing_obj",
          value: {
            ...features_routing_obj,
            data: {
              ...features_routing_obj?.data,
              [routing_active_uuid]: {
                point: new_features_routing_point,
                lineString: new_feature
              }
            }
          },
        },
      });

      setTimeout(() => {
        map_object.setFeatureState(
          { source: "geojson_routing_line", id: routing_active_uuid },
          { selected: true }
        );
      }, 100);

      dispatch(status_toolbox());

      return new_feature

    }
    return null;
  }
}

// export const toolbox_handle_routing = () => async (dispatch, getState) => {
//   const { toolbox = {}, layer = {} } = getState();
//   const { map_object } = layer;
//   const { routing_profile, routing_active_uuid, features_routing_obj = {} } = toolbox;
//   const profile = get_transportation_profiles(routing_profile);
//   let base_url = "https://api.mapbox.com/directions/v5/"

//   let features_routing_point = features_routing_obj?.data?.[routing_active_uuid]?.point || [];
//   let new_features_routing_point = [];
//   if (profile?.mapbox && features_routing_point?.length >= 2) {
//     base_url += profile.mapbox;
//     const coordinates = features_routing_point.map(f => {
//       return `${f.geometry.coordinates[0]},${f.geometry.coordinates[1]}`
//     }).join(";")
//     const url = `${base_url}//${coordinates}?geometries=geojson&overview=full&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`
//     const response = await axios.get(url);
//     if (response.status === 200) {
//       const { geometry, duration, distance } = response.data.routes[0] || {};
//       let old_feature = features_routing_obj?.data?.[routing_active_uuid]?.lineString;
//       let new_feature;
//       // const last_feature_uuid = features_routing_obj?.order?.at(-1);
//       // console.log("last_id_tool", console.log("last_id_tool", features_routing_obj?.data?.[last_feature_uuid]))
//       // const last_id_tool = features_routing_obj?.data?.[last_feature_uuid]?.lineString?.properties?.id_tool?.split("-")?.at(-1)
//       // const id_tool = `Ro-${!isNaN(last_id_tool) ? Number(last_id_tool) + 1 : 1}`;
//       // console.log("new id_tool", id_tool)
//       if (old_feature) {
//         new_feature = {
//           ...old_feature,
//           geometry: geometry,
//           properties: {
//             ...old_feature.properties,
//             routing_profile: routing_profile, //driving, walking, cycling
//             // id_tool,
//             duration_sec: duration,
//             distance_m: distance
//           },
//         }
//       } else {
//         new_feature = {
//           type: "Feature",
//           properties: {
//             uuid: routing_active_uuid,
//             routing_profile: routing_profile, //driving, walking, cycling
//             // id_tool,
//             duration_sec: duration,
//             distance_m: distance
//           },
//           geometry: {
//             type: "LineString",
//             coordinates: geometry.coordinates,
//           },
//         };

//       }

//       for (const [index, item] of features_routing_point.entries()) {
//         const waypoints = response.data?.waypoints || [];
//         let name = waypoints[index]?.name;
//         if (!name || !isNaN(name)) {
//           const url_point = `https://nominatim.mapid.io/reverse?lat=${item.geometry.coordinates[1]}&lon=${item.geometry.coordinates[0]}&format=json`
//           const response_point = await axios.get(url_point);
//           const display_name = response_point?.data?.display_name;
//           const { road, neighbourhood, village, country } = response_point?.data?.address || {}
//           if (road && isNaN(road)) name = road;
//           else if (neighbourhood) name = neighbourhood;
//           else if (village) name = village;
//           else if (country) name = country;
//           else if (display_name && isNaN(display_name)) name = display_name;
//           else name = item.geometry.coordinates.map(number => Number(number).toFixed(5)).join(", ");
//         }

//         new_features_routing_point.push({
//           ...item,
//           properties: {
//             ...item.properties,
//             routing_profile: routing_profile, //driving, walking, cycling
//             name: name,
//             distance_m: waypoints[index]?.distance || 0,
//           },
//         })
//       }

//       dispatch({
//         type: "set_value_toolbox",
//         payload: {
//           key: "features_routing_obj",
//           value: {
//             ...features_routing_obj,
//             data: {
//               ...features_routing_obj?.data,
//               [routing_active_uuid]: {
//                 point: new_features_routing_point,
//                 lineString: new_feature
//               }
//             }
//           },
//         },
//       });

//       setTimeout(() => {
//         map_object.setFeatureState(
//           { source: "geojson_routing_line", id: routing_active_uuid },
//           { selected: true }
//         );
//       }, 100);

//       dispatch(status_toolbox());

//       return new_feature

//     }
//     return null;
//   }
// }

// export const generate_isokron = (feature) => async (dispatch) => {
//   try {
//     const feature_new = { ...feature };

//     dispatch(set_loading_toolbox("generate_isokron"));

//     const [long, lat] = feature_new.geometry.coordinates;
//     let { isochrone_profile, contour_type, contours_minutes, contours_meters } =
//       feature_new.properties;

//     isochrone_profile = isochrone_profile || "driving";
//     contour_type = contour_type || "minutes";
//     contours_minutes = contours_minutes || 5;
//     contours_meters = contours_meters || 500;

//     let url;
//     if (contour_type === "minutes") {
//       url = `https://api.mapbox.com/isochrone/v1/mapbox/${isochrone_profile}/${long},${lat}?contours_minutes=${contours_minutes}&polygons=true&denoise=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`;
//     } else {
//       url = `https://api.mapbox.com/isochrone/v1/mapbox/${isochrone_profile}/${long},${lat}?contours_meters=${contours_meters}&polygons=true&denoise=1&access_token=${process.env.REACT_APP_MAPBOX_API_KEY}`;
//     }
//     const response = await axios.get(url);
//     const geometry = response.data.features[0].geometry;
//     feature_new.geometry = geometry;

//     const get_most_west_coordinate = (feature_polygon) => {
//       if (
//         !feature_polygon ||
//         !feature_polygon.geometry ||
//         !feature_polygon.geometry.coordinates
//       ) {
//         throw new Error("Invalid polygon feature.");
//       }
//       const coordinates = feature_polygon.geometry.coordinates[0];
//       let most_west_coordinate = coordinates.reduce((prev, curr) => {
//         return curr[0] < prev[0] ? curr : prev;
//       });
//       return most_west_coordinate;
//     };
//     const most_west_coordinate = get_most_west_coordinate(feature_new);
//     feature_new.properties.most_west_coordinate = most_west_coordinate;
//     dispatch({
//       type: "push_value_toolbox",
//       payload: {
//         key: "features_isokron",
//         value: [feature_new],
//       },
//     });
//     dispatch(clear_loading_toolbox());
//     dispatch({
//       type: "status_toolbox",
//     });
//   } catch (error) {
//     console.error("Error fetching isokron:", error);
//   }
// };

export const get_poi_inside_polygon = (body) => async (dispatch) => {
  try {
    dispatch(set_loading_toolbox("get_poi_inside_polygon"));

    let skip = 0;
    const limit = 100;
    const feature = body?.feature;
    const geo_layer_ids = body?.geo_layer_ids;
    const is_get_fields = body?.is_get_fields || false;

    const url = `${bun_server}/sini_v2/insight_poi/get_poi_inside_polygon`;
    const all_features = [];
    const all_fields = [];
    let has_next = false;
    do {
      let body = {
        polygon: feature.geometry,
        skip: skip,
        limit: limit,
        is_get_fields
      };
      if (geo_layer_ids?.length > 0) body.geo_layer_ids = geo_layer_ids;
      const response = await axios.post(url, body);
      const { hasNext, features, fields } = response?.data || {};
      has_next = hasNext;
      all_features.push(...features);
      if (fields?.length > 0) all_fields.push(...fields);
      skip += limit;
    } while (has_next);

    return {
      features: all_features,
      fields: all_fields,
    };

  } catch (error) {
    console.error("Error in get_poi_inside_polygon:", error);
  }
};

const getMinMaxAvg = (features) => {
  if (!features || features.length === 0) {
    return { min: undefined, max: undefined, avg: undefined, count: 0 };
  }

  let min = features[0]["properties"]["elevation_m"];
  let max = features[0]["properties"]["elevation_m"];
  let sum = 0;

  // Iterate through the array once
  for (let i = 0; i < features.length; i++) {
    const value = features[i]["properties"]["elevation_m"];

    if (value < min) {
      min = value;
    }
    if (value > max) {
      max = value;
    }
    sum += value;
  }

  const avg = sum / features.length;

  return { min, max, avg, count: features.length };
}